import React from 'react';
import cs from 'classnames';
import {connect} from 'react-redux';

import Button from '~/components/common/Button';
import mapDispatch from '~/misc/mapDispatch';
import Input from '../MyAccount/share/Input';
import DropDown from '~/components/common/DropDown';
import LabeledInput from '~/components/common/LabeledInput';
import {MenuList, MenuListItem} from '~/components/common/MenuList';
import store from '~/store';
import {addUserToAccountAndGetNewList, hideAsyncErrorMessage} from '~/modules/adminAccountPage/actions';
import {regEmail} from '~/misc/reg';
import {hideErrorMsg} from '~/misc/hideErrorMsg';
import {errorInfoConfig} from '~/misc/error-info';

import css from './index.css';

const titles = {
  admin: 'Admin',
  user: 'User',
};

class AddUserPop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      controlData: {
        email: {
          error: '',
          canClick: false,
        },
        userRole: {
          error: '',
          canClick: true,
        },
      },
      formData: {
        email: '',
        userRole: 'Admin',
      },
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.toggleUserRole = this.toggleUserRole.bind(this);
    this.addUser = this.addUser.bind(this);
  }

  render() {
    const formData = this.state.formData;
    const controlData = this.state.controlData;

    return (
      <div className={css.popwrap}>
        <h1 className={css.header}> Add Users </h1>
        <form className={css.formWrap}>
          <div className={cs(css.itemWrap, css.lefPart)}>
            <Input
              mods={['floatLef', 'strench']}
              title={'Email'}
              label={'email'}
              defaultValue={formData.email}
              fnBlur={this.handleBlur}
              fnChange={this.handleChange}
              error = {controlData.email.error}
            />
          </div>
          <div className={css.itemWrap}>
            <DropDown
              data-qa={'add-user-role-dropdown'}
              id={'add-user-role-dropdown'}
              wrapClassName={css.dropdown}
              closeByClick={true}
              trigger={
                <LabeledInput
                  data-qa={'add-user-role-dropdown-input'}
                  large={true}
                  value={formData.userRole ? titles[formData.userRole.toLowerCase()] : 'Admin'}
                  icon='solidDropdown'
                  tags={false}
                  readOnly={true}
                  blackLabel='blackLabel'
                  label={'Role'}
                  greyOutline={true}
                />
              }
              content={
                (<div className={cs(css.dropdownContent, css.itemWrap, css.overHid)}>
                  <MenuList multi={true} data-qa={'menu-list-user-role'} >
                    {Object.keys(titles).map((k, num) => (<MenuListItem
                      greyStyle={true}
                      className={cs('qa-item', `qa-item-${k}`, css.roleItem)}
                      key={num + k}
                      num={num}
                      name={formData.userRole ? titles[formData.userRole.toLowerCase()] : 'Admin'}
                      selected={this.initSelect(formData.userRole, k)}
                      fn={this.toggleUserRole}
                      title={titles[k]}
                    />))}
                  </MenuList>
                </div>)
              }
            />
          </div>
        </form>
        <div className={css.btnWrap}>
          {this.props.addAccountControlData
            && this.props.addAccountControlData.error
            && (<div className={css.error}>
              {hideErrorMsg('addAccountControlData', this.props.addAccountControlData, hideAsyncErrorMessage)}
            </div>)
          }
          {(controlData.email.canClick && controlData.userRole.canClick)
            ? <Button onClick={this.addUser} className={css.wide} mods={['large', 'action']}>Submit</Button>
            : <Button className={css.wide} mods={['large', 'action']}>Submit</Button>
          }
        </div>
      </div>
    );
  }

  processDataAndSetState(type, errorTips, inputVal) {
    const newControlData = Object.assign(this.state.controlData, {[type]: {error: errorTips, canClick: false}});
    const data = Object.assign(this.state.formData, inputVal);
    return this.setState({
      formData: data,
      controlData: newControlData,
    });
  }

  handleBlur(e) {
    if (!e.target.value) {
      return this.processDataAndSetState(e.target.name, errorInfoConfig.email.empty, {[e.target.name]: e.target.value});
    }
    if (!regEmail.test(e.target.value)) {
      return this.processDataAndSetState(e.target.name, errorInfoConfig.email.wrong, {[e.target.name]: e.target.value});
    }
    return null;
  }

  handleChange(e) {
    const data = Object.assign(this.state.formData, {[e.target.name]: e.target.value});

    return this.setState({
      controlData: {
        ...this.state.controlData,
        [e.target.name]: {
          error: '',
          canClick: true,
        },
      },
      formData: data,
    });
  }

  toggleUserRole(e) {
    const data = Object.assign(this.state.formData, {userRole: e.target.textContent.toLowerCase()});
    return this.setState({
      controlData: {
        ...this.state.controlData,
        userRole: {
          error: '',
          canClick: true,
        },
      },
      formData: data,
    });
  }

  initSelect(propsData, menuData) {
    if (propsData && (propsData.toLowerCase() === menuData.toLowerCase())) {
      return true;
    }
    return null;
  }

  addUser() {
    const data = Object.assign(this.state.formData, {accountEmail: this.props.accountInfo.data.accountEmail});
    return store.dispatch((dispatch, getState) => addUserToAccountAndGetNewList(dispatch, getState, data));
  }
}

export default connect(({adminAccountPage}) => ({
  accountInfo: adminAccountPage.accountInfo,
  addAccountControlData: adminAccountPage.addAccountControlData,
}), mapDispatch({
  
}))(AddUserPop);




// WEBPACK FOOTER //
// ./src/components/pages/AddUserPop/index.js